import React from 'react';
import SectionHeader from './SectionHeader';
import SectionHeader2 from './SectionHeader2';
import ProductInfo from './ProductInfo';
import Insta from './Insta';
import AboutUs from './AboutUs';
import './../../style/Container.css';

class Container extends React.Component{

    render(){
        return (
            <div className="app-container">
                <ProductInfo/>
                <SectionHeader2/>
                <Insta/>
                <SectionHeader/>
                <AboutUs/>
            </div>
        )
    }
}
      
export default Container;


// WEBPACK FOOTER //
// ./src/components/container/Container.js